/**
 * PersonIDGenerator - Generates unique person identifiers
 * 
 * Provides unique IDs for tracking individuals across frames.
 * Uses incremental counter for simplicity and performance.
 * IDs are temporary and not persistent across sessions.
 * 
 * Validates Requirements 1.3, 2.2
 */

import type { PersonID } from '../../types';

/**
 * Generates unique person IDs using an incremental counter.
 * IDs are prefixed with 'person-' for clarity.
 */
export class PersonIDGenerator {
  private counter: number = 0;

  /**
   * Generate a new unique person ID.
   * @returns A unique PersonID string
   */
  generateID(): PersonID {
    this.counter++;
    return `person-${this.counter}`;
  }

  /**
   * Reset the counter (useful for testing).
   */
  reset(): void {
    this.counter = 0;
  }

  /**
   * Get the current counter value (useful for testing).
   * @returns Current counter value
   */
  getCurrentCount(): number {
    return this.counter;
  }
}
